import React from "react"
import TableHolder from "../components/TableHolder"
import { useTranslation } from "react-i18next"

const config = {
  data: [
    { name: "wqe", quantity: "1" },
    { name: "wqe", quantity: "1" },
  ],
  headers: [
    { name: "name", title: "Name" },
    { name: "quantity", title: "Quantity" },
  ],
  inner: {
    data: [
      { name: "wqe", quantity: "1" },
      { name: "wqe", quantity: "1" },
    ],
    headers: [
      { name: "name", title: "Name" },
      { name: "quantity", title: "Quantity" },
    ],
  },
}

const BatchsPage = () => {
  const { t } = useTranslation()
  return (
    <>
      <div>
        <h2>{t("BatchsPage")}</h2>
        <TableHolder config={config} />
      </div>
    </>
  )
}

export default BatchsPage
